'use strict';

angular.module('metabuyer.services.taxes', ['ngResource'])
  .factory('taxList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.tax.list,
      {
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('taxesMasterDataList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.tax.masterList,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'},
        'post': {method: 'POST'},
        'put': {method: 'PUT'}
      }
    );
  })
  .factory('taxesSearch',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.tax.search,
      {
        query: '@query'
      },
      {
        'get': { method: 'GET' }
      }
    );
  });
